import { useMemo } from "react";
import moment from "moment";

const useProductData = (fetchData) => {
  const data = fetchData;
  console.log("checking data in Customer", fetchData);

  const formattedData = useMemo(() => {
    const rows = [];

    if (data && Array.isArray(data)) {
      data.forEach((customer, index) => {
        if (customer.Orders && customer.Orders.length > 0) {
          const order = customer.Orders;

          const row = {
            id: index + 1,
            // picture: product.Pictures.map((picture) => ({
            //   id: picture.id,
            //   picture: picture.pic
            //     .split("http")
            //     .filter(Boolean)
            //     .map((url) => `http${url.trim()}`),
            // })),
            // product_id: product.product_id,
            // product_code: product.product_code,
            // product_name: product.product_name,
            // category: product.category_id,
            // detail: product.detail,
            // blemishes: product.blemishes,
            // size: product.size,
            // price: product.price,
            // total_price: product.total_price,
            // total_amount: product.total_amount,
            // created_date: moment(customer.created_date).format(
            //   "DD/MM/YYYY\n เวลา HH:mm:ss น."
            // ),
            // updated_date: moment(customer.updated_date).format(
            //   "DD/MM/YYYY\n เวลา HH:mm:ss น."
            // ),
            // customer_id: customer.id,
            order: customer.Orders,
            customer_name: customer.name,
            idcard: customer.idcard,
            customer_image: customer.image,
            address: customer.address,
            phonenumber: customer.phonenumber,
            company_name: customer.Company.company_name,
          };

          rows.push(row);
        }
      });
    }

    return rows;
  }, [data]);

  return formattedData;
};

export default useProductData;
